import { render, staticRenderFns } from "./SignupTemplateStartupForm.vue?vue&type=template&id=8d5170e6"
import script from "./SignupTemplateStartupForm.vue?vue&type=script&lang=js"
export * from "./SignupTemplateStartupForm.vue?vue&type=script&lang=js"
import style0 from "./SignupTemplateStartupForm.vue?vue&type=style&index=0&id=8d5170e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports